module.exports = __webpack_public_path__ + "img/advantage2@2x.c80bb177.png";